import {SectionView} from '../../ui_canvas_engine/SectionView'
import {PIXI} from '@colonist/pixi'

export class UIInvisibleBackgroundView extends SectionView {
    constructor(x: number, y: number, w: number, h: number, layer: number, container: PIXI.Container, action: () => void) {
        super(x, y, w, h, container)
        this.setClickAction(action)
        this.zIndex = layer
        container.sortChildren()
    }

    private setClickAction(action: () => void) {
        if(!this.interactive) this.interactive = true
        this.on('click', () => {
            action()
        })
        this.on('tap', () => {
            action()
        })
    }

    drawBg() {
        this.bg = new PIXI.Graphics()
        this.bg.beginFill(0, 0.01)
        this.bg.drawRoundedRect(0, 0, this.width, this.height, 5)
        this.bg.endFill()
        this.addChild(this.bg)
    }
}
